// src/components/BandeauVersionPerimee.jsx — « Une nouvelle version de
// l'application est en ligne. Rechargez la page quand vous aurez fini ce que
// vous faites. »
//
// Le bandeau discret qui manquait le 2026-09-22 au soir : l'onglet de Dimitri
// exécutait le JavaScript d'avant le déploiement et rien ne le lui disait
// (mécanique et fail-open dans src/lib/version-app.js).
//
// Placement : en tête du shell App.jsx (admin + agents + orchestrateur), au-
// dessus de la barre unique — jamais sur les pages publiques voyageur, qui ne
// montent pas ce shell. Charte DS admin, sémantique « warning » (désynchro,
// en attente) : fond doré doux, texte brun, comme la garde d'écriture juste
// au-dessus.
//
// Français simple, deux phrases à l'écran. Pas de jargon : ni « bundle »,
// ni « build », ni « version 3bb6139 » — l'empreinte ne regarde pas Dimitri.
// « quand vous aurez fini ce que vous faites » : recharger emporte une saisie
// en cours, et seuls deux écrans posent un `beforeunload` (parc, paiement) —
// partout ailleurs le clic efface sans un mot. Le texte dit donc l'urgence ET
// la précaution, et rend le « × » moins tentant.
//
// Le « × » n'éteint pas l'alerte : il la reporte de 30 min (sessionStorage,
// try/catch), et un déploiement SUIVANT la fait revenir tout de suite — un
// onglet muet pour toute la session serait l'incident lui-même. Recharger =
// window.location.reload, la seule action qui change quelque chose.

import { useEffect, useState } from "react";
import { DS } from "../lib/ui";
import {
  useVersionApp,
  fermetureEnCours,
  fermerLeBandeau,
} from "../lib/version-app";

export const TEXTE_VERSION_PERIMEE =
  "Une nouvelle version de l'application est en ligne. Rechargez la page quand vous aurez fini ce que vous faites.";

export default function BandeauVersionPerimee(options) {
  const { perimee, serveur } = useVersionApp(options);
  // Compteur qui force un nouveau rendu quand le report de 30 min expire
  // (la fermeture elle-même vit en sessionStorage, pas ici).
  const [, reveiller] = useState(0);

  const fermeture = perimee ? fermetureEnCours(serveur) : null;
  const retourA = fermeture ? fermeture.retourA : null;

  useEffect(() => {
    if (retourA === null) return undefined;
    const timer = setTimeout(
      () => reveiller((n) => n + 1),
      Math.max(0, retourA - Date.now()),
    );
    return () => clearTimeout(timer);
  }, [retourA]);

  if (!perimee || fermeture) return null;

  const fermer = () => {
    fermerLeBandeau(serveur);
    reveiller((n) => n + 1);
  };

  return (
    <div
      role="status"
      data-testid="app-version-perimee"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1000,
        background: DS.warningBg,
        borderBottom: `2px solid ${DS.warning}`,
        padding: "10px 16px",
        display: "flex",
        alignItems: "center",
        gap: 12,
        fontFamily: DS.fontBody,
        boxShadow: "0 2px 8px rgba(0,0,0,.08)",
      }}
    >
      <div
        style={{
          flex: 1,
          fontSize: 13,
          color: DS.warningText,
          lineHeight: 1.4,
        }}
      >
        {TEXTE_VERSION_PERIMEE}
      </div>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          background: DS.warningText,
          color: DS.white,
          border: "none",
          borderRadius: DS.radiusControl,
          padding: "7px 14px",
          fontWeight: 700,
          fontSize: 12,
          cursor: "pointer",
          fontFamily: DS.fontBody,
          whiteSpace: "nowrap",
        }}
      >
        Recharger maintenant
      </button>
      <button
        type="button"
        onClick={fermer}
        aria-label="Fermer"
        style={{
          background: "transparent",
          border: "none",
          fontSize: 18,
          color: DS.warningText,
          cursor: "pointer",
          padding: "2px 6px",
          fontWeight: 700,
          lineHeight: 1,
        }}
      >
        ×
      </button>
    </div>
  );
}
